<template>
    <template v-if="compactView">
        <q-item clickable @click="$emit('onOpenCamera')" data-qs="open-camera-btn">
            <q-item-section avatar>
                <q-icon name="fa-light fa-camera icon default-grey-icon-color" />
            </q-item-section>
            <q-item-section>{{ $t("shared.Take a photo") }}</q-item-section>
        </q-item>
        <q-separator />
        <q-item clickable @click="$emit('onOpenFileExplorer')" data-qs="open-file-explorer-btn">
            <q-item-section avatar>
                <q-icon name="fa-light fa-cloud-arrow-up default-grey-icon-color" />
            </q-item-section>
            <q-item-section>{{ $t("shared.Choose file") }}</q-item-section>
        </q-item>
    </template>
    <template v-else>
        <div class="q-mb-md">
            {{ $t("shared.Take or upload a photo") }}
        </div>
        <div class="flex row gap-l justify-center">
            <div class="box row items-center justify-center" @click="$emit('onOpenCamera')" data-qs="open-camera-btn">
                <div>
                    <q-icon name="fa-light fa-camera icon  default-grey-icon-color" size="48px" />
                </div>
                <div>
                    {{ $t("shared.Take a photo") }}
                </div>
            </div>
            <div class="box row" @click="$emit('onOpenFileExplorer')" data-qs="open-file-explorer-btn">
                <FileSelector @on-file-dragged="(file) => $emit('onFileDragged', file)" />
            </div>
        </div>
    </template>
</template>

<script lang="ts" setup>
import FileSelector from "@/shared/components/file-selector/file-selector.vue";

defineProps<{ compactView: boolean }>();
defineEmits<{ onOpenCamera: []; onOpenFileExplorer: []; onFileDragged: [file: File] }>();
</script>

<style lang="scss" scoped>
.box {
    display: flex;
    height: 215px;
    width: 380px;
    justify-content: center;
    align-items: center;
    text-align: center;
    column-gap: 8px;
    border: 1px dashed $border-color-light;
    cursor: pointer;
    &:hover {
        background: $grey-95;
        border-style: solid;
    }
}
</style>
